export default __webpack_public_path__ + "static/media/vidheroc.5873f453.mp4";